import {
    GridGetRowsError, GridUpdateRowError,
} from '@mui/x-data-grid-pro'
import {
    SkyBaseDataSourceProvider,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/SkyBaseDataGrid.types'

const applyDataToDataSource = <D>(
    data: Array<D | Record<string, unknown>> = [],
    onDataSourceError?: (rowsError: (GridGetRowsError | GridUpdateRowError)) => void,
): SkyBaseDataSourceProvider => {
    return {
        dataSource: {
            getRows: (() => {
                return {
                    rows: data,
                    rowsCount: data.length,
                }
            }),
        },
        onDataSourceError: (e: GridGetRowsError) => {
            // eslint-disable-next-line no-console
            console.log('onDataSourceError', e)
            onDataSourceError?.(e)
        },
    } as unknown as SkyBaseDataSourceProvider
}

export default applyDataToDataSource
